<script>
    import { navigateTo } from 'svelte-router-spa'
    import { region, travelCity, addQuestions } from '../../store.js'

    let showField = false, myTravel
    let isQuestions = (JSON.parse($addQuestions)) ? true : false
    function nxt() {
        if (!myTravel) {
            myTravel = 'NO'
        }
        travelCity.set(myTravel)
        if (isQuestions) {
            navigateTo('addQuestions')
        } else {
            navigateTo('result')
        }
    }
</script>

<main>
    <div class="body">
        <h2>Have you travelled to any area in {$region} aside from your home?</h2>
        <p>Ikaw ba ay nagpunta sa iba pang parte ng {$region} bukod sa iyong bahay?</p>

        <a class="btn" on:click={() => showField = true}>
            <span class="e">Yes</span>
            <span class="f">Oo</span>
        </a>
        <a class="btn" on:click={nxt}>
            <span class="e">No</span>
            <span class="f">Hindi</span>
        </a>

        {#if showField}
        <h3>Please specify</h3>
        <p>Pakilista kung saan</p>
        <textarea bind:value={myTravel} rows="2"></textarea>

        {#if myTravel}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
        {/if}
    </div>
</main>

<style>
h3 {
    color: var(--primary-color)
}
</style>